// src/components/DynamicPageTitle.jsx
import { useEffect } from 'react';
import { useSiteConfig } from '../../hooks/useSiteConfig';

const DynamicPageTitle = ({ 
  children, 
  pageTitle = null, 
  includeTagline = false,
  customDescription = null 
}) => {
  const { siteName, tagline, description, loading } = useSiteConfig();

  useEffect(() => {
    if (loading) return; // Don't update title while loading

    // Build the title based on props
    let title = '';
    
    if (pageTitle) {
      // If specific page title provided: "Page Title - Site Name"
      title = `${pageTitle} - ${siteName}`;
    } else {
      // If no page title, just use site name
      title = siteName;
    }
    
    // Add tagline if requested: "Page Title - Site Name | Tagline"
    if (includeTagline && tagline) {
      title += ` | ${tagline}`;
    }
    
    // Update the document title
    document.title = title;
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      // Use custom description if provided, otherwise use site description
      const descriptionToUse = customDescription || description || tagline;
      if (descriptionToUse) {
        metaDescription.setAttribute('content', descriptionToUse);
      }
    }
    
  }, [siteName, tagline, description, pageTitle, includeTagline, customDescription, loading]);

  // This component doesn't render anything, just handles side effects
  return children || null;
};

export default DynamicPageTitle;